<div
  [class.rc-checkbox--multi-line]="multiLine"
  (click)="updateChanges(!value)"
  class="rc-checkbox"
>
  <span
    [class.rc-checkbox__checkmark--active]="value"
    class="rc-checkbox__checkmark"
  ></span>
  <div [class.overflow]="!multiLine" class="rc-checkbox__text">
    {{ label }}
    <ng-content></ng-content>
  </div>
</div>
